import { render, staticRenderFns } from "./ExtensionOnboarding.vue?vue&type=template&id=7bfc4f20&scoped=true&"
import script from "./ExtensionOnboarding.vue?vue&type=script&lang=js&"
export * from "./ExtensionOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc4f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bfc4f20')) {
      api.createRecord('7bfc4f20', component.options)
    } else {
      api.reload('7bfc4f20', component.options)
    }
    module.hot.accept("./ExtensionOnboarding.vue?vue&type=template&id=7bfc4f20&scoped=true&", function () {
      api.rerender('7bfc4f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExtensionOnboarding.vue"
export default component.exports